<script>
import filter from './filter'
export default {
    mixins: [filter],
    props: {
        // a setting row with a switch, inside the More filters side panel (tasks#211)
        asSwitch: {
            type: Boolean,
        },
    },
}
</script>
<template lang="pug">
    v-switch.dd-filter-switch(
        v-if="asSwitch"
        :input-value="active"
        :label="$t(field.label)"
        :disabled="blocked"
        hide-details
        @change="setValue()"
        )
    //- merchant portal toggle chip (Home, "Insights and actions"): selected = 2px dark ring, no tick
    v-chip.dd-toggle-chip(
        v-else
        :input-value="active"
        :aria-pressed="String(Boolean(active))"
        @click="setValue()"
        :disabled="blocked"
        )
        | {{ $t(field.label) }}
</template>
